var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M65 40C65 54.7201 52.2575 66.48 37.21 64.8475C25.57 63.585 16.175 54.0051 15.1075 42.3451C14.1475 31.855 19.7075 22.53 28.195 17.965C31.275 16.31 35 18.7 35 22.195C35 24.6875 36.6875 27.015 39.145 27.4275C42.2675 27.9525 45 25.53 45 22.5V22.2075C45 18.6875 48.7625 16.32 51.8575 17.995C59.6775 22.225 65 30.5026 65 40Z",
    fill: "#38383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6301 57.4299C38.6226 57.6874 35.3476 57.2674 32.0676 55.6474C28.0651 53.6699 24.9276 50.1274 23.4851 45.9024C21.5276 40.1674 22.5951 34.2499 25.8076 29.7824C26.8176 28.3774 28.8951 28.3724 29.8976 29.7824C31.7576 32.3999 34.5776 34.2649 37.8976 34.8249C38.5951 34.9424 39.3026 34.9999 40.0001 34.9999C44.1626 34.9999 47.8576 32.9549 50.1301 29.8149C51.1451 28.4149 53.2101 28.3999 54.2176 29.8049C57.3801 34.2099 58.4626 40.0324 56.5501 45.7399C54.3901 52.1924 48.4101 56.8499 41.6301 57.4299Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon4);
export default __webpack_public_path__ + "static/media/svc_icon4.5838539774769d9784773543002538d3.svg";
export { ForwardRef as ReactComponent };